import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const ButtonContainer = styled.div`
  width: fit-content;
`
